import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'
import React from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { FieldColorPicker, FormField } from 'components/formKit'
import { TileButton } from 'components/uiKit/Button'
import { Typography } from 'components/uiKit/Typography'
import { BrandTagEdited } from 'services/Branding/components'
import { useBrandColorOptions } from 'services/Branding/fieldConfigs/useFieldConfigs'
import { isAnyEdited } from 'services/Branding/fieldConfigs/utils'
import { genSchema, genBrandField } from 'services/Branding/genSchema'
import { useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { TestResultFormBrandType } from './testResultTypes'

export const STYLE_FORM_SCHEMA = genSchema(SCHEMA.testResult.style, {
  chartCorrectAnswerEmpty: {
    color: genBrandField({
      as: FieldColorPicker<string | null>,
      label: t('input.label.progressBackground'),
      useConfigs: [useBrandColorOptions],
    }),
  },
  chartCorrectAnswerFill: {
    color: genBrandField({
      as: FieldColorPicker<string | null>,
      label: t('input.label.progressCompleted'),
      useConfigs: [useBrandColorOptions],
    }),
  },
  chartFailAnswerEmpty: {
    color: genBrandField({
      as: FieldColorPicker<string | null>,
      label: t('input.label.progressBackground'),
      useConfigs: [useBrandColorOptions],
    }),
  },
  chartFailAnswerFill: {
    color: genBrandField({
      as: FieldColorPicker<string | null>,
      label: t('input.label.progressCompleted'),
      useConfigs: [useBrandColorOptions],
    }),
  },
})

const TestResultFormStyle: TestResultFormBrandType = ({ device, subConfigs, edited, setForm }) => {
  const path = useMemo(() => ['style', device], [device])
  const schema = useUpdateSchema(path, subConfigs, STYLE_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <Padding bottom gap sides>
      <Typography weight='medium'>{t('elements.testResult.tags.correct')}</Typography>
      <FormField config={schema.chartCorrectAnswerEmpty.color} />
      <FormField config={schema.chartCorrectAnswerFill.color} />

      <Typography weight='medium'>{t('elements.testResult.tags.fail')}</Typography>
      <FormField config={schema.chartFailAnswerEmpty.color} />
      <FormField config={schema.chartFailAnswerFill.color} />

      <TileButton
        description={t('uiKit.button.richTextDescription')}
        icon='otherRight'
        name='showFontForm'
        onClick={handleSetTypography}
      >
        <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
        {isAnyEdited(edited.font) && <BrandTagEdited />}
      </TileButton>
    </Padding>
  )
}

export default React.memo(TestResultFormStyle) as typeof TestResultFormStyle
